<template lang="html">
    <div id="coloniesList">
        <div class="rel d-flex justify-content-center align-items-start align-content-start" @click.self="close()"> <!-- clic fuera de la caja = cerrar -->
            <div class="floatRectangle mt-5" role="dialog" aria-modal="true">
                <div class="modalBody d-flex flex-wrap justify-content-start align-items-center align-content-start px-4 px-md-5 py-5">

                    <!-- el encabezado cambia con el estado: si ya sabemos que no hay reparto, el titulo lo dice
                         y deja de contradecir al mensaje de abajo -->
                    <span class="w-100 font-3 titleSelect text-start ts-11">{{ headTitle }}</span>
                    <span class="w-100 font-5 subtitleSelect text-start mt-2">
                        <template v-if="offering">{{ offerSubtitle }}</template>
                        <template v-else-if="mode == 'noCoverage'">{{ phrases.f5[lang] }}</template>
                        <template v-else-if="mode == 'notFound'">{{ phrases.f7[lang] }}</template>
                        <template v-else>{{ phrases.f4[lang] }} <b>{{ cityName }}</b></template>
                    </span>

                    <div class="selectSpace mt-3 px-0 py-0 d-flex" :class="mode != 'search' ? 'quiet' : ''"> <!-- solo se apaga cuando ya sabemos que el reparto no aplica -->
                        <span class="align-items-center align-content-center justify-content-center"><img :src="a11" v-svg-inline></span>
                        <input
                            ref="colonyInput"
                            type="text"
                            class="colonyInput flex-fill font-2 ts-12 ps-2"
                            :placeholder="phrases.f3[lang]"
                            v-model="query"
                            @input="onType">
                    </div>

                    <div class="w-100 px-0 py-0 d-flex position-relative">
                        <div v-if="colonies.length > 0" class="custom-dropdown">
                            <div v-for="(colony, colonyPos) in colonies" :key="colonyPos" @click="pick(colony)" @keydown.enter="pick(colony)" class="text-start ps-3 py-3 font-5" role="button" tabindex="0">
                                {{ formatColony(colony) }}
                            </div>
                        </div>
                    </div>

                    <span v-if="loading" class="w-100 text-start mt-3 font-5 hintText">{{phrases.f6[lang]}}</span>

                    <!-- salida voluntaria a take out: el sistema (y por tanto el menu) se elige aqui, antes de que
                         exista carrito. En el wizard ya seria tarde: cambiar de POS a esas alturas obliga a vaciarlo. -->
                    <div v-if="!offering && !loading && takeoutStores.length > 0" class="w-100 text-start mt-3">
                        <span @click="wantPickup()" @keydown.enter="wantPickup()" class="pickupSwitch font-5" role="button" tabindex="0">{{ phrases.h5[lang] }}</span>
                    </div>

                    <!-- take out: aqui esta la decision, asi que es lo mas pesado de la pantalla -->
                    <div v-if="offering" class="pickupList w-100 mt-3">
                        <div v-for="(store, storePos) in takeoutStores" :key="'pk'+storePos"
                            @click="pickupAt(store)" @keydown.enter="pickupAt(store)"
                            class="pickupOption w-100 d-flex align-items-center text-start px-3 py-3 font-5" role="button" tabindex="0">
                            <span class="pickupInfo flex-fill">
                                <span class="pickupName d-block">{{ store.name }}</span>
                                <span v-if="store.meta" class="pickupMeta d-block">{{ store.meta }}</span>
                            </span>
                            <span v-if="store.openNow !== null" class="pickupState" :class="store.openNow ? 'isOpen' : 'isClosed'">
                                {{ store.openNow ? phrases.f9[lang] : phrases.f10[lang] }}
                            </span>
                            <span class="pickupGo" aria-hidden="true">&rsaquo;</span>
                        </div>
                    </div>

                    <div @click="close()" @keydown.enter="close()" class="closeColonies font-7 d-flex align-items-center align-content-center justify-content-center" role="button" tabindex="0" :aria-label="phrases.f11[lang]">
                        <img :src="a10" v-svg-inline>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import track from '@/assets/js/tracking.js';

export default {
    name:"colonySelector",
    emits:['close', 'select', 'nocoverage', 'pickup'],
    props:{
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        cityGroup:{ //todas las entradas de ciudad que comparten friendlyName (sistemas distintos)
            default:()=>[],
            type: Array
        },
    },
    computed:{
        cityName(){
            return this.cityGroup.length > 0 ? this.cityGroup[0].friendlyName : '';
        },
        mode(){ //estado del modal: de el dependen titulo, subtitulo y peso visual del buscador
            if(this.noCoverage){ return 'noCoverage'; }
            if(this.emptyResult && !this.loading){ return 'notFound'; }
            return 'search';
        },
        offering(){ //mostrando sucursales: porque el reparto no aplica, o porque el usuario lo pidio
            return (this.mode != 'search' || this.pickupChosen) && this.takeoutStores.length > 0;
        },
        lastColonyName(){
            return this.lastColony && this.lastColony.d_asenta ? this.lastColony.d_asenta : '';
        },
        headTitle(){
            //sin reparto: el titulo asume el mensaje en vez de dejarlo como error debajo del "¿a que colonia te enviamos?"
            if(this.mode == 'noCoverage' && this.lastColonyName != ''){
                return this.phrases.h1[this.lang].replace('{colonia}', this.lastColonyName);
            }
            if(this.offering){ return this.phrases.h2[this.lang]; }
            return this.phrases.f1[this.lang];
        },
        offerSubtitle(){
            return this.phrases.h3[this.lang].replace('{n}', this.takeoutStores.length);
        },
        takeoutStores(){ //sucursales del grupo que admiten recoger en tienda (retrocompatible: sin el campo 'takeout' => permitido)
            let list = [];
            for(const entry of this.cityGroup){
                for(const storeNumber in (entry.stores || {})){
                    const store = entry.stores[storeNumber];
                    if(!Object.prototype.hasOwnProperty.call(store, 'takeout') || store.takeout != 0){
                        const openNow = this.storeOpenNow(store);
                        list.push({
                            storeNumber:storeNumber,
                            name:store.name,
                            meta:this.storeMeta(store, openNow),
                            openNow:openNow
                        });
                    }
                }
            }
            return list;
        }
    },
    mounted(){
        //arranque del flujo: denominador de todo el embudo de esta pantalla
        track.tag('colonia_modal_abierto');
        track.variable('ciudad', this.cityName);
        track.variable('sucursales_takeout', this.takeoutStores.length);

        this.escHandler = (ev)=>{ if(ev.key == 'Escape'){ this.close(); } };
        document.addEventListener('keydown', this.escHandler);
        this.prevBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden'; //sin esto el menu de atras sigue haciendo scroll bajo el modal
        this.$nextTick(()=>{ if(this.$refs.colonyInput){ this.$refs.colonyInput.focus(); } });
    },
    unmounted(){
        document.removeEventListener('keydown', this.escHandler);
        document.body.style.overflow = this.prevBodyOverflow;
    },
    methods:{
        storeZone(store){ //ubicacion corta de la sucursal; se pinta sola en cuanto getCities exponga el dato
            const zone = store.colony || store.address || '';
            if(zone == ''){ return ''; }
            let text = String(zone).trim().replace(/^COL\.?\s+/i, '');
            if(store.zipCode){ text += ' · ' + store.zipCode; }
            return text;
        },
        storeMeta(store, openNow){ //segunda linea de la fila: donde queda, o a que hora abre si esta cerrada
            const zone = this.storeZone(store);
            if(zone != ''){ return zone; }
            //sin direccion publicada: al menos decir a que hora abre, para que "Cerrado" no sea un callejon sin salida
            if(openNow === false && store.calendar){
                const open = Number(store.calendar.openPickup);
                if(!isNaN(open)){
                    return this.phrases.h4[this.lang].replace('{hora}', this.formatHour(open));
                }
            }
            return '';
        },
        formatHour(value){
            const hour = Math.floor(value);
            const min = Math.round((value - hour) * 60);
            return String(hour).padStart(2,'0') + ':' + String(min).padStart(2,'0');
        },
        storeOpenNow(store){ //abierto para pickup en este momento, con el gmt de la tienda. null = sin horario publicado
            const cal = store.calendar;
            if(!cal){ return null; }
            const open = Number(cal.openPickup), close = Number(cal.closePickup), gmt = Number(cal.gmt);
            if(isNaN(open) || isNaN(close) || isNaN(gmt)){ return null; }
            const now = new Date();
            let hour = (now.getUTCHours() + (now.getUTCMinutes() / 60) + gmt) % 24;
            if(hour < 0){ hour += 24; }
            if(close > open){ return hour >= open && hour < close; }
            return hour >= open || hour < close; //horario que cruza la medianoche
        },
        offerTakeout(motivo){ //se le muestran las sucursales de take out (una sola vez por sesion de modal)
            if(this.takeoutStores.length <= 0 || this.takeoutOffered){ return; }
            this.takeoutOffered = true;
            track.tag('takeout_ofrecido');
            track.variable('takeout_motivo', motivo); //'sin_reparto', 'colonia_no_encontrada' o 'eleccion_propia'
        },
        wantPickup(){ //el usuario prefiere recoger aunque su colonia si tenga reparto
            this.pickupChosen = true;
            this.colonies = []; //cerrar el dropdown para que no se encime sobre la lista de sucursales
            track.tag('takeout_pedido_por_usuario'); //distinto de 'sin reparto': aqui si habia opcion de envio
            this.offerTakeout('eleccion_propia');
        },
        onType(){
            this.noCoverage = false;
            this.emptyResult = false;
            this.colonies = [];
            this.pickupChosen = false; //volver a escribir = quiere reparto; el boton de recoger reaparece abajo

            if(this.debounce){
                clearTimeout(this.debounce);
            }

            const text = this.query.trim();
            if(text.length < 3){
                this.loading = false;
                return;
            }

            this.loading = true;
            this.debounce = setTimeout(()=>{
                this.search(text);
            }, 400);
        },
        search(text){
            const city = this.cityGroup[0];
            if(!city){ return; }

            this.searchCount += 1;
            track.variable('busquedas_colonia', this.searchCount); //muchas busquedas antes de elegir = le costo trabajo

            const parsedSearch = city.cEstado + "/" + city.cMnpio + "/" + text;
            this.con.getColoniesMatch({token:city.token, url:parsedSearch}).then((res)=>{
                this.loading = false;
                if(res.code == 200){
                    this.colonies = res.data || [];
                    this.emptyResult = this.colonies.length == 0;
                }else{
                    this.colonies = [];
                    this.emptyResult = true;
                }
                if(this.emptyResult){
                    track.tag('colonia_sin_resultados');
                    this.offerTakeout('colonia_no_encontrada');
                }
            }).catch((err)=>{
                this.loading = false;
                this.colonies = [];
                this.emptyResult = true;
                track.tag('colonia_busqueda_fallida'); //error de red/API, no es culpa del usuario
                this.offerTakeout('colonia_no_encontrada');
            });
        },
        pick(colony){
            //colonia sin sucursal/cobertura asignada: informar y ofrecer take out
            if(colony.storeNumber == '' || colony.storeNumber == null || colony.storeNumber == 0){
                this.noCoverage = true;
                this.lastColony = colony;
                this.colonies = []; //cerrar el dropdown para que no se encime sobre el aviso y las sucursales de take out
                this.query = this.formatColony(colony); //dejar la colonia elegida visible en el input
                track.tag('colonia_sin_reparto');
                track.variable('colonia', colony.d_asenta || '');
                this.offerTakeout('sin_reparto');
                this.$emit('nocoverage', colony);
                return;
            }
            this.resolved = true;
            track.tag('colonia_con_reparto'); //camino feliz: no necesito ofrecerle take out
            track.variable('colonia', colony.d_asenta || '');
            this.$emit('select', colony);
        },
        pickupAt(store){ //sin reparto en la colonia: continuar en modo take out con la sucursal elegida
            this.resolved = true;
            track.tag('takeout_elegido');
            track.variable('sucursal_takeout', store.name);
            this.$emit('pickup', {storeNumber:store.storeNumber, colony:this.lastColony});
        },
        formatColony(colony){
            let parts = [];
            if(colony.d_asenta){ parts.push(colony.d_asenta); }
            if(colony.d_tipo_asenta){ parts.push('(' + colony.d_tipo_asenta + ')'); }
            if(colony.d_codigo){ parts.push('· ' + colony.d_codigo); }
            return parts.join(' ');
        },
        close(){
            if(!this.resolved){
                //abandono: cerro sin elegir colonia ni sucursal. Si ya se le habian ofrecido las
                //sucursales de take out, el abandono apunta a la funcion nueva y no a la busqueda.
                track.tag(this.takeoutOffered ? 'takeout_abandonado' : 'colonia_abandonada');
            }
            this.$emit('close');
        },
    },
    data(){
        return{
            query:"",
            colonies:[],
            loading:false,
            noCoverage:false,
            emptyResult:false,
            lastColony:null,
            debounce:null,
            searchCount:0, //cuantas busquedas lanzo antes de resolver
            takeoutOffered:false, //ya se le mostraron las sucursales de take out
            pickupChosen:false, //pidio ver sucursales aunque su colonia tuviera reparto
            resolved:false, //eligio colonia con reparto o sucursal de take out
            escHandler:null,
            prevBodyOverflow:'',
            a10:require('@/assets/images/a10.svg'),
            a11:require('@/assets/images/a11.svg'),
            phrases:{
                f1:{
                    es:"¿A qué colonia te enviamos?",
                    en:"Where do we deliver?"
                },
                f3:{
                    es:"Escribe tu colonia",
                    en:"Type your neighborhood"
                },
                f4:{
                    es:"Reparto en",
                    en:"Delivery in"
                },
                f5:{
                    es:"Esa colonia no tiene servicio de reparto a domicilio.",
                    en:"That neighborhood has no home delivery service."
                },
                f6:{
                    es:"Buscando colonias...",
                    en:"Searching neighborhoods..."
                },
                f7:{
                    es:"No encontramos colonias con ese nombre.",
                    en:"No neighborhoods found with that name."
                },
                f8:{
                    es:"Pero puedes ordenar y recoger en sucursal (take out):",
                    en:"But you can order for store pickup (take out):"
                },
                f9:{
                    es:"Abierto",
                    en:"Open"
                },
                f10:{
                    es:"Cerrado",
                    en:"Closed"
                },
                f11:{
                    es:"Cerrar",
                    en:"Close"
                },
                h1:{ //la colonia va en el titulo: el usuario ve su respuesta, no un error generico
                    es:"No llegamos a {colonia}",
                    en:"We don't deliver to {colonia}"
                },
                h2:{ //sin colonia identificada pero si hay sucursales que ofrecer
                    es:"Recoge en sucursal",
                    en:"Pick up in store"
                },
                h3:{
                    es:"Puedes ordenar y recoger tu pedido en {n} sucursales",
                    en:"You can order and pick up at {n} stores"
                },
                h4:{
                    es:"Abre a las {hora}",
                    en:"Opens at {hora}"
                },
                h5:{
                    es:"Prefiero recoger en sucursal",
                    en:"I'd rather pick up in store"
                }
            }
        }
    }
}
</script>
<style lang="css" scoped>
    #coloniesList{
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(0px);
        z-index: 4000;
        position: fixed;
        top:0;
        left:0;
        animation:appear 0.2s linear 1 forwards;
    }
    .rel{
        position: relative;
        width: 100%;
        height: 100%;
    }
    .floatRectangle{
        width: 700px;
        max-width: 90%;
        min-height: 300px;
        max-height: calc(100vh - 6rem); /* mt-5 arriba + aire abajo: la caja nunca se sale de la pantalla */
        background-color: #fff;
        position: absolute;
        display: flex;
        animation:append 0.4s linear 1 forwards;
    }
    .modalBody{
        /* sin position:relative a proposito: asi la X se ancla a .floatRectangle */
        width: 100%;
        /* NO poner overflow aqui: el dropdown de colonias es position:absolute y su bloque contenedor
           cae dentro de este div, asi que cualquier overflow!=visible lo recorta. El scroll va en
           .pickupList, que nunca convive con el dropdown (pick() limpia colonies antes de ofrecer take out). */
        overflow: visible;
    }
    .titleSelect{
        color:var(--primary);
        user-select: none;
    }
    .subtitleSelect{
        color:var(--text10);
    }
    .hintText{
        color:var(--text10);
    }
    .errorText{
        color:var(--primary);
    }
    .selectSpace{
        width: 100%;
        height: 70px;
        border:3px solid var(--text10);
        box-sizing: border-box; /* antes era 100vw + content-box: solo cabia porque flex-shrink lo rescataba */
        transition: border-color 0.2s linear, opacity 0.2s linear;
    }
    .selectSpace.quiet{ /* ya cumplio su funcion: cede el peso visual a las sucursales */
        border-width: 1px;
        opacity: 0.75;
    }
    .selectSpace svg{
        width: 30px;
    }
    .selectSpace span{
        display: flex;
        width: 70px;
        height: 70px;
        color: var(--text10);
        align-items:center;
        justify-content:center;
    }
    .colonyInput{
        height: 100%;
        border: 0;
        outline: none;
        background-color: transparent;
        color: var(--primary);
    }
    .colonyInput::placeholder{
        color: var(--text10);
    }
    .closeColonies{
        position: absolute;
        width: 50px;
        background-color: #fff; /* el contenido scrollea por debajo: sin fondo la X se encima con el texto */
        height: 50px;
        right: 10px;
        padding-bottom: 10px;
        font-size: 40px;
        color:var(--primary);
        top: 10px;
        z-index: 2;
    }
    .closeColonies svg{
        height: 25px;
        pointer-events: none
    }
    @keyframes append {
        0%{
            transform: translateY(-150%);
            opacity: 0.3;
        }
        90%{
            transform: translateY(20%);
        }
        100%{
            transform: translateY(0%);
            opacity: 1;
        }
    }
    @keyframes appear {
        0%{
            backdrop-filter: blur(0px);
            background-color: rgba(18,18,18,0);
        }
        100%{
            backdrop-filter: blur(8px);
            /* el blur solo no basta: sin capa oscura el header rojo y las fotos de atras
               compiten con el modal (y el rojo del fondo choca con el rojo del titulo) */
            background-color: rgba(18,18,18,0.55);
        }
    }
    .custom-dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        max-height: 260px;
        overflow-y: auto;
        border-bottom:3px solid var(--text10);
        border-left:3px solid var(--text10);
        border-right:3px solid var(--text10);
        z-index: 10;
    }
    .custom-dropdown div {
        cursor: pointer;
        color: var(--primary);
        background-color: var(--octagenary);
        border-bottom: 3px solid var(--text10);
    }
    .custom-dropdown div:last-child {
        border-bottom: none;
    }
    .custom-dropdown div:hover {
        background-color: #ddd;
    }
    .pickupSwitch{ /* accion secundaria: existe, pero no le pelea el peso a la busqueda de colonia */
        color: var(--primary);
        cursor: pointer;
        text-decoration: underline;
        text-underline-offset: 3px;
    }
    .pickupSwitch:hover{
        opacity: 0.75;
    }
    .pickupSwitch:focus-visible{
        outline: 3px solid var(--primary);
        outline-offset: 2px;
    }
    .pickupList{
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        /* el scroll vive aqui: acota la unica parte que crece con los datos, sin recortar el dropdown */
        max-height: calc(100vh - 21rem);
        min-height: 150px;
        overflow-y: auto;
    }
    .pickupOption {
        cursor: pointer;
        color: var(--primary);
        background-color: var(--octagenary);
        border: 3px solid var(--text10);
        box-sizing: border-box;
        transition: background-color 0.15s linear, border-color 0.15s linear;
    }
    .pickupOption:hover {
        background-color: #ddd;
        border-color: var(--primary);
    }
    .pickupInfo{
        min-width: 0; /* sin esto un nombre largo empuja el chip y la flecha fuera de la fila */
    }
    .pickupName{
        font-weight: 700;
        line-height: 1.2;
    }
    .pickupMeta{ /* donde queda la sucursal, o a que hora abre: sin esto el usuario elige a ciegas */
        color: #6b6b6b;
        font-size: 0.82em;
        line-height: 1.3;
        margin-top: 2px;
    }
    .pickupState{
        flex: 0 0 auto;
        margin-left: 12px;
        padding: 2px 10px;
        font-size: 0.75em;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        white-space: nowrap;
        border: 2px solid currentColor;
    }
    .pickupState.isOpen{ color: #1b7f3b; }
    .pickupState.isClosed{ color: #6b6b6b; } /* var(--text10) quedaba ilegible sobre el hover gris */
    .pickupGo{ /* afordancia: la fila es un boton, no un renglon de texto */
        flex: 0 0 auto;
        margin-left: 10px;
        font-size: 1.6em;
        line-height: 1;
        color: var(--primary);
    }
    /* el teclado tiene que ver donde esta parado: colonias, sucursales y la X */
    .custom-dropdown div:focus-visible,
    .pickupOption:focus-visible,
    .closeColonies:focus-visible{
        outline: 3px solid var(--primary);
        outline-offset: 2px;
    }
    @media (prefers-reduced-motion: reduce){
        #coloniesList, .floatRectangle{
            animation-duration: 0.01ms;
        }
    }
</style>
